<template>
    <div class="FieldContainer">
        <div v-if="!isSet">
            <WText
                v-if="field.type"
                :size="12"
                color="gray02"
                class="CaptionLabel"
            >
                {{ $t('filters.field.operator') }}
            </WText>
            <div class="OperatorsContainer">
                <WSelect
                    v-model="operator"
                    :options="operators"
                    name="operator"
                    :placeholder="$t('filters.field.operatorPlaceholder')"
                    @input="handleInput({ cleanValues: true })"
                />
            </div>
        </div>
        <WText
            :size="12"
            color="gray02"
            class="CaptionLabel"
        >
            {{ $t('filters.field.values') }}
        </WText>
        <WSelect
            v-if="isSet"
            v-model="setValues"
            :options="formattedSetOptions"
            :name="field.field"
            :closeOnSelect="false"
            :placeholder="$t('filters.field.valuePlaceholder')"
            multiple
            @input="handleInput"
        />
        <div
            v-else-if="isRange"
            class="RangeValuesContainer"
        >
            <div class="SplitInputWrapper">
                <WInput
                    v-model="value"
                    :type="filterType"
                    :name="field.field"
                    :disabled="!operator"
                    :placeholder="$t('filters.field.minValue')"
                    class="ValueInput split"
                    @input="handleInput"
                />
            </div>
            <div class="SplitInputWrapper">
                <WInput
                    v-model="valueTo"
                    :type="filterType"
                    :name="field.field"
                    :disabled="!operator"
                    :placeholder="$t('filters.field.maxValue')"
                    class="ValueInput split"
                    @input="handleInput"
                />
            </div>
        </div>
        <WInput
            v-else
            v-model="value"
            :type="filterType"
            :name="field.field"
            :disabled="!operator"
            :placeholder="$t('filters.field.textPlaceholder')"
            @input="handleInput"
        />
        <div
            v-if="removeVisible"
            class="ActionsContainer"
        >
            <WButton
                color="link"
                iconLeft="trash"
                size="sm"
                :iconSize="12"
                @click="removeFilter"
            >
                {{ $t('filters.field.remove') }}
            </WButton>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { OPERATORS_BY_FILTER_TYPE, getFilterTypeByFieldType, formatFlagOptions } from '../constants'

export default {
    name: 'FieldFilter',
    props: {
        field: VueTypes.object,
        filter: VueTypes.object,
        setOptions: VueTypes.array,
        removeVisible: VueTypes.bool,
    },
    data () {
        return {
            value: '',
            valueTo: '',
            setValues: [],
            operator: '',
        }
    },
    computed: {
        filterType () {
            return getFilterTypeByFieldType(this.field.type)
        },
        operators () {
            return OPERATORS_BY_FILTER_TYPE[this.filterType]
        },
        isSet () {
            return this.filterType === 'set'
        },
        isNumber () {
            return this.filterType === 'number'
        },
        isString () {
            return this.filterType === 'text'
        },
        isRange () {
            return this.operator === 'inRange'
        },
        formattedSetOptions () {
            const { field, setOptions } = this
            return field.type === 'flag' ? formatFlagOptions(setOptions) : setOptions
        },
    },
    watch: {
        filter: {
            immediate: true,
            handler (newFilter) {
                this.storeValuesFromFilter(newFilter)
            },
        },
        field: {
            immediate: true,
            handler () {
                if(this.isNumber){
                    this.operator = 'equals'
                } else if(this.isString){
                    this.operator = 'contains'
                }
            }
        }
    },
    methods: {
        cleanValues () {
            this.value = ''
            this.valueTo = ''
            this.setValues = []
        },
        storeValuesFromFilter (filter) {
            this.value = filter.value
            this.valueTo = filter.valueTo
            this.setValues = filter.setValues
            this.operator = filter.operator
        },
        handleInput ({ cleanValues }) {
            if (cleanValues) this.cleanValues()
            this.$emit('input', {
                value: this.value,
                valueTo: this.valueTo,
                setValues: this.setValues,
                operator: this.operator,
            })
        },
        removeFilter () {
            this.$emit('remove')
        },
    },
}
</script>

<style lang="scss">
.multiselect__tags {
    overflow: hidden;
}
.FieldContainer {
    padding-top: 8px;
    padding-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid $gray-05;
}
.OperatorsContainer {
    margin-bottom: 6px;
}
.RangeValuesContainer {
    display: flex;
    flex-direction: row;
}
.ValueInput {
    width: 100%;
}
.SplitInputWrapper {
    width: 50%;
    &:first-child {
        padding-right: 2px;
    }
    &:last-child {
        padding-left: 2px;
    }
}
.CaptionLabel {
    margin-bottom: 2px;
}
.ActionsContainer {
    width: 100%;
    margin-top: 6px;
}
</style>
